import { useEffect } from 'react';

import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useClientData } from '@/providers/ClientData.provider';

const { api } = vopayApi;

type GetAccountRequest = {
  ContactID: string;
};

type SaveAccountEmailRequest = GetAccountRequest & {
  EmailAddress: string;
};

export default function useContact() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const {
    response: { clientAccountsEnabled },
  } = useClientData();

  const getContact = async (params: GetAccountRequest) => {
    try {
      if (clientAccountsEnabled) {
        const res = await api.fetchClientAccountList({
          ClientAccountID: params.ContactID,
        });
        if (!res.Success) throw new Error(res.ErrorMessage);
        return res.ClientAccounts[0];
      } else {
        const res = await api.fetchContacts({
          ContactID: params.ContactID,
        });
        if (!res.Success) throw new Error(res.ErrorMessage);
        return res.Contacts[0];
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const saveContactEmail = async (params: SaveAccountEmailRequest) => {
    try {
      const res = clientAccountsEnabled
        ? await api.editClientAccount({
            ClientAccountID: params.ContactID,
            EmailAddress: params.EmailAddress,
          })
        : await api.editContact({
            ContactID: params.ContactID,
            EmailAddress: params.EmailAddress,
          });

      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    getContact,
    saveContactEmail,
  };
}
